// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_RefundsListInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /payroll/refunds
 *
 * All filters are optional query params. The model (payroll_refunds_model
 * ::listRefunds) casts/escapes each value itself, so these are kept as raw
 * nullable strings to preserve the legacy `$this->input->get(...)` behavior of
 * passing the raw query value (or null when absent) into the filters array.
 */
import { registerContract } from './validate'

export interface Payroll_RefundsListInput {
status?: string
franchise_id?: string
period_id?: string
pays_to?: string
exclude_paid?: string
}

registerContract('Payroll_RefundsListInput', {
  status:       { type: 'string',  required: false },
  franchise_id: { type: 'string',  required: false },
  period_id:    { type: 'string',  required: false },
  pays_to:      { type: 'string',  required: false },
  exclude_paid: { type: 'string',  required: false },
})
